module.exports = function() {
    if (!this.opts.checkbox) {
        return [];
    }

    const getters = this.$store.getters;

    return getters[`${this.name}_CHECKBOX/getSelected`];
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/computed/get-checkbox-selected.js